var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g(_vm._b({class:_setup.twMerge(
      'flex cursor-pointer items-center justify-center bg-white px-3 py-2 text-sm text-gray-900 hover:bg-gray-50 disabled:pointer-events-none disabled:opacity-50',
      _vm.twClass,
    ),attrs:{"role":"menuitem"}},'div',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }